<template>
  <a class="author with-avatar" href="#">
    <img alt :src="current.image" v-if="current" />
    <span  v-if="current">{{ current.name }}</span>
    <img v-if="!current" alt />
    <span v-if="!current">Anónimo</span>
  </a>
</template>

<script>
export default {
  props: {
    current: {
      type: Object
    }
  },
  mounted() {},
  methods: {}
};
</script>
